
import { createOrder } from '@hobs/actions/orders';
import { RaisedButton } from '@hobs/components/Buttons';
import Icon from '@hobs/components/Icon';
import Toast from '@hobs/components/Toast';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

const OrderButton = ({ assignmentIds = [], t, createOrder, history }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const thisCreateOrder = async () => {
        setIsSubmitting(true);
        const response = await createOrder({ assignmentIds: assignmentIds });

        if (response.success) {
            Toast.success(t('Order draft successfully created'));
            history.push(`/order/${response.payload.orderId}`);
        } else {
            Toast.warning(response.payload.message);
        }
        setIsSubmitting(false);
    }

    return (
        <RaisedButton
            onClick={thisCreateOrder}
            type="button"
            disabled={isSubmitting || assignmentIds.length === 0}
            iconLeft={<Icon icon="plus" />}
        >
            {t('Create order')}
        </RaisedButton>
    )
}

OrderButton.propTypes = {
    assignmentIds: PropTypes.array,
    //mapDispatchToProps
    createOrder: PropTypes.func,
    //withTranslation
    t: PropTypes.func,
    //withRouter
    history: PropTypes.object
}

const mapDispatchToProps = {
    createOrder
}

export default connect(null, mapDispatchToProps)(
    withTranslation()(
        withRouter(
            OrderButton
        )
    )
);